// extracted by mini-css-extract-plugin
export default {"urlWrapper":"share-url-styles__urlWrapper__XSI33","url":"share-url-styles__url__Mxd2G"};